import { forEach } from 'lodash';
import Media from "../helpers/matchMediaGenerator";

export default (() => {
  const createAccordion = (accordion, media) => {
    const title = accordion.querySelector('.accordion__title');

    const clickEvent = () => {
      const accordionContent = accordion.querySelector('.accordion__content');

      if (accordion.classList.contains('accordion--open')) {
        accordion.classList.remove('accordion--open');
        accordionContent.removeAttribute('style');
      } else {
        accordion.classList.add('accordion--open');
        accordionContent.setAttribute('style', 'height: auto;');
        const realAccordionHeight = accordionContent.clientHeight;
        accordionContent.removeAttribute('style');

        setTimeout(() => {
          accordionContent.setAttribute('style', `height: ${realAccordionHeight}px`);
        }, 1);
      }
    };

    title.addEventListener('click', () => {
      if (media) {
        if (media.matches) {
          clickEvent();
        }
      } else {
        clickEvent();
      }
    });
  };

  const init = () => {
    const accordions = document.querySelectorAll('.accordion:not(.accordion--mobileOnly)');
    const mobileOnlyAccordions = document.querySelectorAll('.accordion--mobileOnly');
    const mobileMedia = Media.getMedia([0, 768]);

    forEach(accordions, accordion => createAccordion(accordion));

    forEach(mobileOnlyAccordions, (accordion) => {
      createAccordion(accordion, mobileMedia);
    });
  };

  return {
    init,
  };
})();
